import React, { ReactElement } from 'react'
import RoutersSection from './Sections/RoutersSection'
import OperatingSystemsSection from './Sections/OperatingSystemsSection'
import WebBrowsersSection from './Sections/WebBrowsersSection'
import RemoteMonitoringSection from './Sections/RemoteMonitoringSection'
import OtherSection from './Sections/OtherSection'
import ReadyToGetStarted from 'components/Organization/Features/CommonSections/RedyToGetStarted'
import FeaturePageLayout from 'components/Organization/LandingPageCommonComponents/LandingPageLayout'
import HeroIcon from 'images/integrations/hero.svg'
import HeroSection from 'components/Organization/LandingPageCommonComponents/HeroSection'
import SectionDivider from 'components/Organization/LandingPageCommonComponents/SectionDivider'
import FrequentlyAskedQuestions from 'components/FrequentlyAskedQuestions'
import { frequentlyAskedQuestions } from './Sections/frequentlyAskedQuestions'
import TrustedByExperts from 'components/Organization/Features/TrustedByExperts/TrustedByExperts'

export default function Integrations(): ReactElement {
  return (
    <FeaturePageLayout>
      <HeroSection title="Integrations & Trusted Partners" svg={HeroIcon} sx={{ mb: 0 }} />
      <SectionDivider />

      <RoutersSection />
      <SectionDivider />

      <OperatingSystemsSection />
      <SectionDivider />

      <WebBrowsersSection />
      <SectionDivider />

      <RemoteMonitoringSection />
      <SectionDivider />

      <OtherSection />
      <SectionDivider />

      <TrustedByExperts />
      <SectionDivider />

      <FrequentlyAskedQuestions data={frequentlyAskedQuestions} />
      <SectionDivider />

      <ReadyToGetStarted />
    </FeaturePageLayout>
  )
}
